import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  institutes: [],
  institutesUserData:{},
  loading: false,
  error: null,
  singleInstitutes:{},
  totalPage:1
};

const instituteSlice = createSlice({
  name: 'institute',
  initialState,
  reducers: {
    addInstitute(state) {
      state.loading = true;
    },
    addInstituteSuccess(state,action) {
      state.loading = false;
      state.error = null;
      state.institutesUserData=action.payload;
    },
    addInstituteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addDroneManufacturer(state) {
      state.loading = true;
    },
    addDroneManufacturerSuccess(state,action) {
      state.loading = false;
      state.error = null;
      state.institutesUserData=action.payload;
    },
    addDroneManufacturerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getInstitutes(state) {
      state.loading = true;
    },
    getInstitutesSuccess(state, action) {
      state.loading = false;
      state.institutes = action.payload.currentPage!=1? [...state.institutes, ...action.payload.data]:action.payload.data;
      state.totalPage = action.payload.totalPages;
      state.error = null;
    },
    getInstitutesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleInstitutes(state) {
      state.loading = true;
    },
    getSingleInstitutesSuccess(state, action) {
      state.loading = false;
      state.singleInstitutes = action.payload;
      state.error = null;
    },
    getSingleInstitutesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { addDroneManufacturer,addDroneManufacturerSuccess,addDroneManufacturerFailure,getSingleInstitutes,getSingleInstitutesSuccess,getSingleInstitutesFailure, addInstitute, addInstituteSuccess, addInstituteFailure ,getInstitutes,getInstitutesSuccess,getInstitutesFailure} = instituteSlice.actions;

export default instituteSlice.reducer;
